import { Controller } from "@hotwired/stimulus";

const formatVariableName = (str) => {
  if (str == null) return "";

  // Convert to string and uppercase
  str = String(str).toUpperCase();

  // Replace spaces with underscores
  str = str.replace(/\s+/g, "_");
  
  // Remove invalid characters (keep only A-Z, 0-9, and _)
  str = str.replace(/[^A-Z0-9_]/g, "");
  
  // Remove multiple consecutive underscores
  str = str.replace(/_+/g, "_");
  
  // Ensure it starts with a letter or underscore
  if (str.match(/^[0-9]/)) {
    str = "_" + str;
  }

  return str;
};

export class VariableNameController extends Controller {
  static targets = ["input"];

  connect() {
    this.lastValue = this.inputTarget.value;
  }

  formatOnInput(e) {
    if (e.target.value !== this.lastValue) {
      let caretPosition = e.target.selectionStart;

      this.lastValue = formatVariableName(e.target.value);
      e.target.value = this.lastValue;

      // Restore caret position
      e.target.setSelectionRange(caretPosition, caretPosition);
    }
  }

  formatOnPaste(e) {
    setTimeout(() => {
      this.formatOnInput(e);
    }, 10);
  }

  formatOnBlur(e) {
    this.lastValue = formatVariableName(e.target.value);
    e.target.value = this.lastValue;
  }
}

export default VariableNameController;
